import { getCurrentCulture } from '@vp/culture-resolution'

export default class AuthProvider {
  static initAuthConfig() {
    // const developmentMode = process.env.VP_AUTH_DEVELOPMENT_MODE === 'true'
    // const windowLocationOrigin = typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : null
    const config = {
      options: { requireSession: true },
      culture: getCurrentCulture(),
      developmentMode: false,
    }
    // if (process.env.AUTH_CONNECTION) {
    //   config.options = { connection: process.env.AUTH_CONNECTION }
    // }

    // if (developmentMode) {
    //   if (process.env.AUTH_CLIENT_ID) {
    //     config.developmentMode.clientID = process.env.AUTH_CLIENT_ID
    //     if (windowLocationOrigin) {
    //       config.developmentMode.redirectUriOrigin = windowLocationOrigin
    //     }
    //   }
    // }

    return config
  }
}
